import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { toast } from 'react-toastify';
import { UserRole } from '../../types/ApiTypes';
import { useAuth } from '../hooks/useAuth';

interface RoleMiddlewareProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

export const RoleMiddleware = ({ children, allowedRoles }: RoleMiddlewareProps) => {
  const { isLoading, user, isAuthenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && allowedRoles && user && !allowedRoles.includes(user.role)) {
      toast.error("You don't have permission to access this page");
    }
  }, [location.pathname, isLoading, allowedRoles, user]);

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/overview" replace />;
  }

  return <>{children}</>;
};
